import { isMobile } from 'react-device-detect';
import OrderCreate from './OrderCreate';
import MobileOrderCreate from './MobileOrderCreate';

const CustomOrderView = () => {
  console.log('mobile:', isMobile);
  if (isMobile) {
    return <MobileOrderCreate />;
  } else {
    return <OrderCreate />;
  }
};

export default CustomOrderView;
